import { parseCurrency } from '@helper/parseCurrency'

export const parseFollowUpOtbFooterData = (data: any[]): any[] => {
  const res = []
  let estoqueInicial = 0
  let estoqueAtual = 0
  let vendaRealizada = 0
  let vendasProjetadasPCL = 0
  let vendasProjetadasPlanoDeCompra = 0
  let estoqueFinal = 0

  data.forEach(obj => {
    return (estoqueInicial += obj.estoqueInicialEmCusto)
  })
  data.forEach(obj => {
    return (estoqueAtual += obj.estoqueAtualEmCusto)
  })
  // data.forEach(obj => {
  //   return (recebido += obj.recebidos)
  // })
  data.forEach(obj => {
    return (vendaRealizada += obj.vendasRealizadasEmCusto)
  })
  // data.forEach(obj => {
  //   return (recebimentosProgramados += obj.recebimentosProgramados)
  // })
  data.forEach(obj => {
    return (vendasProjetadasPCL += obj.vendasProjetadasEmCusto)
  })
  data.forEach(obj => {
    return (vendasProjetadasPlanoDeCompra += obj.estoqueProjetadoEmCusto)
  })
  // data.forEach(obj => {
  //   return (otbPlanejamento += obj.openToBuy)
  // })
  data.forEach(obj => {
    return (estoqueFinal += obj.quantidadeAReceberEmCusto)
  })
  res.push({
    // 'periodo-descricao': '',
    'empresa-codigo': '',
    'produto-codigo': '',
    'produto-descricao': '',
    'gerente-categoria-codigo': '',
    'gerente-categoria-descricao': '',
    'gerente-produto-codigo': '',
    'gerente-produto-descricao': '',
    'categoria-compacta-codigo': '',
    'categoria-compacta-descricao': '',
    'categoria-codigo': '',
    'categoria-descricao': '',
    'mundo-codigo': '',
    'mundo-descricao': '',
    'indicador-estoque-inicial': parseCurrency({
      value: estoqueInicial,
      country: 'pt-br'
    }),
    'indicador-estoque-atual': parseCurrency({
      value: estoqueAtual,
      country: 'pt-br'
    }),
    // 'indicador-rec-mes': parseCurrency({
    //   value: recebido || 0,
    //   country: 'pt-br'
    // }),
    'indicador-vd-real': parseCurrency({
      value: vendaRealizada,
      country: 'pt-br'
    }),
    // 'indicador-areceber': parseCurrency({
    //   value: recebimentosProgramados,
    //   country: 'pt-br'
    // }),
    // recebimentosProgramados,
    'indicador-vd-planej-pcl': parseCurrency({
      value: vendasProjetadasPCL,
      country: 'pt-br'
    }),
    'indicador-vd-planej-proj': parseCurrency({
      value: vendasProjetadasPlanoDeCompra,
      country: 'pt-br'
    }),
    // 'indicador-open-to-by': parseCurrency({
    //   value: otbPlanejamento,
    //   country: 'pt-br'
    // }),

    'indicador-estoque-final-ajust': parseCurrency({
      value: estoqueFinal,
      country: 'pt-br'
    })
  })

  return res
}
